// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__chip--iISmf {
  background-color: #fff;
  border: 1px solid #7d8287;
  border-radius: 1.5rem;
  outline: none;
  color: #000;
  padding: 0.5rem 0.75rem;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  min-width: 88px;
  height: 2.5rem;
  font-family: 'Inter Regular', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}
.style__chip--iISmf:hover:not(.style__chipSelected--VUOeS):not(.style__chip--iISmf:disabled) {
  background-color: #95999d;
}
.style__chip--iISmf:focus:not(.style__chipSelected--VUOeS):not(.style__chipNegative--DgBjJ) {
  background-color: #afb2b6;
}
.style__chip--iISmf:active {
  background-color: #c4ffcb;
}
.style__chip--iISmf:disabled {
  color: #62656a;
}
.style__chipSelected--VUOeS {
  background-color: #c4ffcb;
  border-color: #00ee77;
}
.style__chipNegative--DgBjJ {
  background-color: #ffe5e0;
  border-color: #ff513d;
}
`, "",{"version":3,"sources":["webpack://./../components/src/Chip/style.less"],"names":[],"mappings":"AAGA;EAEI,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAHJ;AAKI;EACE,yBAAA;AAHN;AAMI;EACE,yBAAA;AAJN;AAOI;EACE,yBAAA;AALN;AAQI;EACE,cAAA;AANN;AASI;EACE,yBAAA;EACA,qBAAA;AAPN;AAUI;EACE,yBAAA;EACA,qBAAA;AARN","sourcesContent":["@import '../colors';\n@import '../spacing';\n\n:local {\n  .chip {\n    background-color: @color-white;\n    border: 1px solid @color-asphalt-grey-050;\n    border-radius: @spacing-150;\n    outline: none;\n    color: @color-black;\n    padding: @spacing-50 @spacing-75;\n    display: flex;\n    gap: @spacing-50;\n    justify-content: center;\n    align-items: center;\n    min-width: 88px;\n    height: @spacing-250;\n    font-family: 'Inter Regular', sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 18px;\n\n    &:hover:not(&Selected):not(&:disabled) {\n      background-color: @color-asphalt-grey-060;\n    }\n\n    &:focus:not(&Selected):not(&Negative) {\n      background-color: @color-asphalt-grey-070;\n    }\n\n    &:active {\n      background-color: @color-green-095;\n    }\n\n    &:disabled {\n      color: @color-asphalt-grey-040;\n    }\n\n    &Selected {\n      background-color: @color-green-095;\n      border-color: @color-green-neon;\n    }\n\n    &Negative {\n      background-color: @color-red-095;\n      border-color: @color-red-060;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip": `style__chip--iISmf`,
	"chipSelected": `style__chipSelected--VUOeS`,
	"chipNegative": `style__chipNegative--DgBjJ`
};
export default ___CSS_LOADER_EXPORT___;
